import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/closed`;

export interface ForceCloseFileCommandPayload {
  fileId: string;
  comment?: string;
  toCustomerComment?: string;
}

export const forceCloseFileRequest = ({
  fileId,
  comment,
  toCustomerComment,
}: ForceCloseFileCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { comment, toCustomerComment },
  },
});

async function forceCloseFileCommand({
  fileId,
  comment,
  toCustomerComment,
}: ForceCloseFileCommandPayload): Promise<BaseBackResponse> {
  try {
    return await executeQuery<BaseBackResponse>(
      forceCloseFileRequest({ fileId, comment, toCustomerComment }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default forceCloseFileCommand;
